import React, { useState } from 'react';
import { Button } from 'react-bootstrap5';
import {
  Link, useLocation, useParams, useNavigate,
} from 'react-router-dom';

import routes from 'app/routes';
import SummaryView from 'components/ProgramBuilder/Summary';
import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';
import StepTab from 'components/new_ui/Tabs/StepTab';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Summary() {
  const { templateId } = useParams();
  const { state: { data, selectedTopics, template } } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { dispatch: dispatchTemplates, actions: actionsTemplates } = useTemplatesContext();

  const onSave = () => {
    setLoading(true);
    actionsTemplates.update(dispatchTemplates, templateId, data, () => {
      setLoading(false);
      navigate(routes.managers.templates.index);
    });
  };

  return (
    <>
      <StepTab total={3} current={3} />

      <div className="content">
        <section>
          <h1>Summary</h1>
        </section>

        <section>
          <SummaryView data={data} />
        </section>

        <footer className="d-flex justify-content-between">
          <Link
            to={routes.managers.templates.editOrderTopics(templateId)}
            className="btn btn-outline-primary"
            state={{
              selectedTopics,
              template,
              data,
            }}
          >
            Previous
          </Link>

          <Button
            onClick={onSave}
            disabled={loading}
          >
            {loading && <LoadingPlaceholder placement="inline" />}
            {' '}
            Save
          </Button>
        </footer>
      </div>
    </>
  );
}
